package presentation.screens.person

import models.PersonDetails
import utils.UiAction
import utils.UiState

data class PersonState(
    val isLoading: Boolean = true,
    val isError: Boolean = false,
    val isFullBiography: Boolean = false,
    val person: PersonDetails? = null,
) : UiState

sealed interface PersonMVIAction : UiAction {
    data object Reload : PersonMVIAction
    data object BackClicked : PersonMVIAction
    data object ToggleBiography : PersonMVIAction
    data object OpenFilmography : PersonMVIAction
    data class OnVideoClicked(val id: Int, val isTvShow: Boolean) : PersonMVIAction
}
